import { NodeRenderer } from '@contentful/rich-text-react-renderer';

interface IDAnchorLinkContent {
  data: object;
  marks: [];
  nodeType: string;
  value: string;
}

export const EntryHyperlink: NodeRenderer = (node) => {
  if (node.data?.target?.sys?.contentType?.sys?.id === 'idAnchor') {
    const idAnchorLinkContent = node.content[0] as IDAnchorLinkContent;
    const idAnchorLinkText = idAnchorLinkContent.value;
    const htmlId = node.data.target.fields.htmlId;

    return (
      /*
        Exceptional use: temporarily disabling "jsx-a11y/anchor-is-valid" for
        this link type as it's not possible to employ a11y's suggestion of a
        <button> inside a Rich Text Editor.
      */
      /* eslint-disable jsx-a11y/anchor-is-valid */
      <a
        className="text-indigo"
        href="#"
        id={htmlId}
        onClick={(e) => e.preventDefault()}
      >
        {idAnchorLinkText}
      </a>
    );
  } else {
    // If needed, handle other cases of INLINES.ENTRY_HYPERLINK here
    return null;
  }
};
